export const MD = {
    MD_ERROR: "market-data.error",
    MARKET_DATA_UPDATE: "market-data.data-update",
    MARKET_DATA_BATCH_UPDATE: "market-data.batch-update",

    // Market Reference Data
    MD_SET_REF_FETCH_STATUS: "md.set.ref-fetch-status",
    MD_TOGGLE_REF_SIDEBAR: "md.toggle.ref-sidebar",
    MD_SAVE_REF_DATA: "md.save.ref-data",
    MD_RESET_REF: "md.reset.ref",

    // Exchange Rates
    MD_SET_EX_RATES: "md.set.ex-rates",
};
